import { useQuery } from "@tanstack/react-query";
import { getMe } from "../api/lkUsers.js";

/**
 * Probes the current session via GET /v1/lk/me.
 * retry: false — let the caller decide what to show on network errors.
 * staleTime: 30s — avoids hammering the server on every page visit.
 */
export function useSessionProbe() {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    retry: false,
    staleTime: 30_000,
  });

  return { data, isLoading, isError, refresh: refetch };
}
